export default "__VITE_ASSET__X1IbDO$B__"